import angular from 'angular'

run.$inject = ['$rootScope', '$transitions']

export default function run($rootScope, $transitions) {
  $rootScope.appTitle = 'Flexiquit'

  $transitions.onSuccess({}, function($transition) {
    if (angular.isDefined($transition.injector().get('$title'))) {
      $rootScope.pageTitle = $transition.injector().get('$title')
    }
  })
}